export default Object.freeze({
  critics: "criticscore",
  fan: "fanscore",
  image_type: "certified",
});
